module.exports = __webpack_public_path__ + "static/media/chevron-right.025096b9.svg";